// extracted by mini-css-extract-plugin
export default {"loaders":"main_loaders__DIOcN","spin":"main_spin__rhyPM","div":"main_div__uGwvp","loader":"main_loader__jJXkM"};